import React, { useEffect, useState, useContext } from "react";
import Col from "react-bootstrap/Col";
import { colors, resolveColor } from "utils/styles";
import DynamicLink from "./DynamicLink";
import dynamic from "next/dynamic";
import CheckOutButton from "components/CartComponents/CheckOutButton";
import { valueOrDefault } from "utils/helpers";
import ConditionalWrapper from "components/Reusables/ConditionalWrapper";

/**
 *
 * @param {btn1, btn2,} Object with only two buttons, text, and links/onclick handlers TODO
 * @returns
 */
export default function ButtonGroup(props) {
	if (props.buttonGroupData?.fields?.productAddToCart) {
		const AddToCartButton = dynamic(() => import("../AddToCartButton"), {
			loading: () => <div />,
			ssr: false,
		});

		let variant = props.buttonGroupData.fields.productAddToCart.fields;
		let product = props.buttonGroupData.fields.productAddToCart.fields.product.fields;
		variant = { ...product, ...variant };
		return <AddToCartButton variantData={variant} buttonGroupData={props.buttonGroupData} custom={true} />;
	}
	const [disabled, setDisabled] = useState(false);

	let {
		additionalClasses,
		alignButtons,
		btn1,
		btn2,
		btnHeight,
		button1Children,
		button1Variant,
		button2Children,
		button2Variant,
		buttonGroupData,
		buttonWidth,
		fontSize,
		groupClasses,
		isDisabled,
		onClick = () => {}, //not sure if this will ever come from contentful, but good for manually using component
		outlineColor,
		paddingBottom,
		paddingTop,
		title,
	} = props;
	const fields = buttonGroupData?.fields;

	useEffect(() => {
		setDisabled(isDisabled);
	}, [isDisabled]);

	if (fields && fields?.button1Text) {
		btn1 = {};
		btn1.text = fields.button1Text;
		btn1.url = fields.button1Url;
		btn1.renderAsLinkBtn1 = fields.renderAsLinkBtn1;
		if (fields.button2Text) {
			btn2 = {};

			btn2.text = fields.button2Text;
			btn2.url = fields.button2Url;
			btn2.renderAsLinkBtn2 = fields.renderAsLinkBtn2;
		}
	}
	outlineColor = outlineColor ? outlineColor : resolveColor(fields?.outlineColor);

	fontSize = fontSize ? fontSize : fields?.fontSize ? fields.fontSize : "15";
	groupClasses = groupClasses ? groupClasses : fields?.groupClasses ? fields?.groupClasses : " ";
	button1Variant = button1Variant ? button1Variant : fields?.button1Variant ? fields?.button1Variant : "dark";
	button2Variant = button2Variant ? button2Variant : fields?.button2Variant ? fields?.button2Variant : "dark";
	alignButtons = valueOrDefault(alignButtons || fields?.alignButtons, "start");
	paddingBottom = paddingBottom ? paddingBottom : fields?.paddingBottom ? fields?.paddingBottom : 0;
	paddingTop = paddingTop ? paddingTop : fields?.paddingTop ? fields?.paddingTop : 0;
	additionalClasses = additionalClasses
		? additionalClasses
		: fields?.additionalClasses
		? fields?.additionalClasses
		: "";
	const btnBaseClasses = `btn-styles w-100 d-flex justify-content-center px-1 py-1 cursor-pointer rounded mb-${paddingBottom} mt-${paddingTop} ${
		additionalClasses || ""
	} ${outlineColor ? "outline-color" : ""}`;
	const btn1Class = `${btnBaseClasses} btn-outline-${button1Variant}`;
	const btn2Class = `${btnBaseClasses} btn-outline-${button2Variant}`;
	buttonWidth = buttonWidth
		? buttonWidth
		: fields?.buttonWidth
		? fields?.buttonWidth
		: { xs: 12, sm: btn2 ? 6 : 12, md: 6 };

	const instantBuy = fields?.instantBuy;
	if (instantBuy) {
		return (
			<CheckOutButton
				variantId={instantBuy}
				text={btn1?.text}
				btnVariant={button1Variant}
				align={fields?.alignButtons}
			/>
		);
	}

	return (
		<div
			style={{ zIndex: 2 }}
			ref={props.myRef}
			className={`d-flex btn-group  row g-0 w-100 ButtonGroupComponent  ${groupClasses}
		  ${alignButtons ? `justify-content-${alignButtons}` : ""} 
		`}
			// className={``}
			role="group"
			aria-label="Button Group"
		>
			{/* <div
			
			> */}
			<Col title={title} className={`d-flex ${btn2 ? "pe-sm-1 pb-1 pb-sm-0" : " "} `} {...buttonWidth}>
				<ConditionalWrapper
					condition={btn1?.url}
					wrapper={(children) => (
						<DynamicLink textDecoration={"none"} href={btn1.url} classes="w-100">
							{children}
						</DynamicLink>
					)}
				>
					{/* <DynamicLink textDecoration={"none"} href={btn1.url} classes="w-100"> */}
					{btn1?.renderAsLinkBtn1 && (
						<span
							onClick={onClick}
							className={`as-link d-flex align-items-center  my-0 py-0 px-0 btn-text ${btnBaseClasses} link-button`}
							style={{ paddingBottom: '2px' }}
						>
							{btn1?.text} {button1Children && button1Children}
						</span>
					)}
					{!btn1?.renderAsLinkBtn1 && (
						<button disabled={disabled} onClick={onClick} type="button" className={`${btn1Class} `}>
							<span className="d-flex align-items-center  my-0 py-0 px-0 btn-text">
								{btn1?.text} {button1Children && button1Children}
							</span>
						</button>
					)}
				</ConditionalWrapper>
				{/* </DynamicLink> */}
			</Col>

			{btn2 && (
				<Col className="d-flex ps-sm-1 pt-1 pt-sm-0" {...buttonWidth}>
					<ConditionalWrapper
						condition={btn1?.url}
						wrapper={(children) => (
							<DynamicLink textDecoration={"none"} href={btn2.url} classes="w-100">
								{children}
							</DynamicLink>
						)}
					>
						{/* <DynamicLink textDecoration={"none"} href={btn2.url} classes="w-100"> */}
						{btn2.renderAsLinkBtn2 && (
							<span
								onClick={onClick}
								className={`as-link d-flex align-items-center  my-0 py-0 px-0 btn-text ${btnBaseClasses} link-button`}
							style={{ paddingBottom: '2px' }}
							>
								{btn2?.text} {button2Children && button2Children}
							</span>
						)}
						{!btn2.renderAsLinkBtn2 && (
							<button disabled={isDisabled} type="button" className={`${btn2Class}`}>
								<span className=" my-0 py-0 px-0 btn-text">
									{btn2?.text} {button2Children && button2Children}
								</span>
							</button>
						)}
					</ConditionalWrapper>
					{/* </DynamicLink> */}
				</Col>
			)}
			{/* </div> */}
			<style jsx="true">{`
				.outline-color {
					border: 2px solid ${outlineColor} !important;
				}
				.as-link {
					color: ${colors.green} !important;
				}
				a:hover {
					text-decoration: none !important;
				}

				.btn-text {
					color: inherit;
					font-size: ${fontSize}px;
				}
				.btn-styles {
					cursor: pointer;

					margin: 0;
					align-items: center;
					min-height: ${btnHeight || "3em"};

					font-family: "Open Sans";
					line-height: 18px;
					font-weight: bold;
					display: flex;
					justify-content: space-evenly;
					transition: all 0.2s;

					text-decoration: none;
				}
				.btn-styles:hover:not(.link-button) {
					box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.4);
				}
				.btn-styles:disabled {
					box-shadow: none;
					filter: brightness(80%) !important;
					cursor: not-allowed;
				}

				.btn-outline-dark {
					background: ${colors.darkBlue};
					color: ${colors.white};
				}
				.btn-outline-dark:hover {
					filter: brightness(130%);
				}

				.btn-outline-light {
					background: ${colors.white};
					color: ${colors.darkBlue};
					border: 1px solid black;
				}
				.btn-outline-light:hover {
					background: ${colors.white};
					color: ${colors.darkBlue};
				}

				.btn-outline-transparent {
					background: transparent;
					color: ${colors.darkBlue};
					border: 1px solid black;
				}
				.btn-outline-transparent:hover {
					color: ${colors.darkBlue};
				}

				.btn-outline-yellow {
					color: ${colors.white};

					background: ${colors.yellow};
				}
				.btn-outline-yellow:hover {
					filter: brightness(110%);
				}
				.btn-outline-mediumYellow {
					color: ${colors.white};

					background: ${colors.mediumYellow};
				}
				.btn-outline-mediumYellow:hover {
					filter: brightness(110%);
				}
				.btn-outline-purple {
					color: ${colors.white};

					background: ${colors.purple};
				}

				.btn-outline-mediumRed {
					background: ${colors.mediumRed};
					color: ${colors.white};
				}
				.btn-outline-mediumRed:hover {
					filter: brightness(110%);
				}

				.btn-outline-red {
					background: ${colors.red};
					color: ${colors.white};
				}
				.btn-outline-red:hover {
					filter: brightness(110%);
				}

				.btn-outline-mediumBlue {
					background: ${colors.mediumBlue};
					color: ${colors.white};
				}
				.btn-outline-mediumBlue:hover {
					filter: brightness(110%);
				}

				.btn-outline-light-blue {
					background: ${colors.lightBlue};
					color: ${colors.white};
				}
				.btn-outline-light-blue:hover {
					filter: brightness(110%);
				}

				.btn-outline-green {
					color: ${colors.white};

					background: ${colors.green};
				}
				.btn-outline-green:hover {
					filter: brightness(110%);
				}

				.cursor-pointer {
					cursor: pointer;
				}

				.link-button {
					position: relative;
					text-decoration: none !important;
					color: black !important;
					width: fit-content !important;
					margin-left: 10px !important;
					align-items: center !important;
					margin-right: 10px !important;
				}
				
				.link-button::after {
					content: "";
					position: absolute;
					bottom: 0;
					left: 0;
					width: 100%;
					height: 2px;
					background-color: #D4A574;
					transition: all 0.3s ease;
				}
				
				.link-button:hover {
					text-decoration: none !important;
				}
				
				.link-button:hover::after {
					background-color: #B8945F;
					transform: scaleX(1.1);
				}
			`}</style>
		</div>
	);
}
